export enum RegionIdMap {
  // HK: 22
  EATIGO_HONG_KONG = 22,
  // MY: 23
  EATIGO_KUALA_LUMPUR = 23,
  // PH: 24~26
  EATIGO_LUZON = 24,
  EATIGO_VISAYAS = 25,
  EATIGO_MINDANAO = 26,
  // SG: 27
  EATIGO_SINGAPORE = 27,
  // TH: 28~32
  EATIGO_BANGKOK = 28,
  EATIGO_CHONBURI = 29,
  EATIGO_CHIANG_MAI = 30,
  EATIGO_PHUKET = 31,
  EATIGO_SONGKLA = 32,
  // TW: 137
  EATIGO_TAIPEI = 137,
}

export enum RegionCodeMap {
  HK = 'HK',
  MY = 'MY',
  PH = 'PH',
  SG = 'SG',
  TH = 'TH',
  TW = 'TW',
}
